import { TextInput } from "grommet";
import { forwardRef } from "react";

const CustomInput = forwardRef(function CustomInput(props, ref) {
  const { ...otherProps } = props;
  return <TextInput {...otherProps} ref={ref} focusIndicator={false} plain />;
});

export default CustomInput;
